import _ from 'lodash';
import { showError, showModal } from 'controls/modals';

export {
  showError, showModal,
};

export const handleError = (fn, errorMessage = '', { rethrow = false, silent = false } = {}) => async (dispatch, ...rest) => {
  try {
    return await fn(dispatch, ...rest);
  } catch (err) {
    errorMessage = _.isFunction(errorMessage) ? errorMessage(dispatch, ...rest) : errorMessage;
    let exceptionMessage = _.isString(err)
      ? err : _.isObject(err)
        ? err.message || err.messages || err.responseText || JSON.stringify(err)
        : 'An unknown error has ocurred';

    if (!_.isString(exceptionMessage)) {
      exceptionMessage = JSON.stringify(exceptionMessage);
    }

    if (process.env.NODE_ENV !== 'production') {
      console.error(err);
    }

    if (!silent) {
      dispatch(showError({ title: errorMessage || undefined, text: exceptionMessage }));
    }

    if (rethrow) {
      throw new Error(`${errorMessage}\n${exceptionMessage}`);
    }
  }
};
